module.exports = __webpack_public_path__ + "img/tepeztate-plant.b55d7d57.png";